import { render, staticRenderFns } from "./userTrend.vue?vue&type=template&id=06466c7d&scoped=true&"
import script from "./userTrend.vue?vue&type=script&lang=js&"
export * from "./userTrend.vue?vue&type=script&lang=js&"
import style0 from "./userTrend.vue?vue&type=style&index=0&id=06466c7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06466c7d",
  null
  
)

export default component.exports